module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('CouponButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CP" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v("Code: " + _vm._s(_vm.item.code))])]), (_vm.item.common_cost !== null) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.common_cost.reason))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.item.common_cost.amount, _vm.item.common_cost.tax).toFixed(2))))])]) : _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Discount " + _vm._s(_vm.item.discount_rate) + "%")])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Valid from")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Valid to")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Max Uses")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.max_uses === null ? 'unlimited' : _vm.item.max_uses))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Max Uses per driver")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.max_uses_per_driver === null ? 'unlimited' : _vm.item.max_uses_per_driver))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Max Days")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.max_days === null ? 'unlimited' : _vm.item.max_days))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Service")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.service === null ? 'All' : _vm.item.service))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aaa06dd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Coupon.vue
// module id = 2125
// module chunks = 1